// @flow

import type { State } from "@store/reducers";
import type { EmployeePositionsState } from "@modules/shared/reducer/employee-positions/types";
import type { RoleSummary } from "@modules/employee/reducer/employment-details/types";

export const getSharedEmployeePositions = (state: State): EmployeePositionsState =>
  state.shared.employeePositions;

export const getEmployeePositions = (state: State): Array<RoleSummary> =>
  getSharedEmployeePositions(state).list.content;

export const getEmployeePositionsPagination = (state: State) => {
  const list = getSharedEmployeePositions(state).list;
  return {
    ...list.pagination,
    totalElements: list.totalElements,
  };
};
